<template>
	<article class="d-search-page-custom">
		<div class="bg-primary px-layout-margin pb-xl min-h-screen">
			<nav
				class="flex justify-end items-center h-lg py-xs"
				style="min-height: 1.5em"
			>
				<a
					class="
						inline-flex
						items-center
						font-semibold
						text-primary-button text-button
						uppercase
					"
					style="margin-right: -0.5em"
					:href="backlink"
					target="_self"
				>
					Luk søgning

					<SvgCrossIcon
						class="ml-2xs"
						style="width: 1em; height: 1em"
					/>
				</a>
			</nav>
			<div v-once class="d-search-page-custom__cludo-container">
				<!-- ========================== -->
				<!-- RESULTS CONTAINER TEMPLATE -->
				<!-- vvvvvvvvvvvvvvvvvvvvvvvvvv -->
				<div id="cludo-search-results" class="cludo-search-results">
					<div
						id="cludo-search-input"
						class="cludo-input-form"
						role="search"
					>
						<input
							id="clu-q"
							ref="search"
							class="cludo-input-form__input"
							name="searchrequest"
							placeholder="Skriv hvad du vil søge efter"
							aria-label="Skriv hvad du vil søge efter"
							type="search"
							autocomplete="off"
							aria-autocomplete="list"
							aria-haspopup="true"
						/>
						<div
							id="clearInput"
							tabindex="0"
							role="button"
							aria-label="Ryd søgning"
						>
							Ryd søgning
						</div>
						<button
							type="submit"
							title="Search"
							class="cludo-input-form__search-button"
							aria-label="Udfør søgning"
						>
							<svg
								width="16"
								height="16"
								viewbox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C8.55414 14 9.99 13.4935 11.1515 12.6366L14.2936 15.7073C14.6841 16.0978 15.3173 16.0978 15.7078 15.7072C16.0983 15.3167 16.0982 14.6835 15.7077 14.293L12.576 11.2324C13.4696 10.057 14 8.59045 14 7C14 3.13401 10.866 0 7 0ZM2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7Z"
									fill="white"
								/>
							</svg>
						</button>
					</div>

					<div
						class="
							cludo-search-results__did-you-mean
							search-did-you-mean
						"
					></div>

					<div
						class="
							w-5col
							>=768:w-8col
							max-w-full
							mx-auto
							cludo-search-results__layout
						"
					>
						<div
							class="cludo-search-results__facets search-filters"
							aria-controls="search-results"
						></div>
						<div class="cludo-search-results__results-wrapper">
							<div
								class="
									cludo-search-results__search-result-count
									search-result-count
								"
								role="status"
							></div>
							<div
								id="search-results"
								class="
									cludo-search-results__results
									search-results
								"
								role="region"
								aria-live="polite"
								aria-label="Søge-resultater"
							></div>
							<div
								id="cludo-load-more"
								tabindex="0"
								class="cludo-hidden"
							>
								<a type="button"
									>Vis flere
									<svg
										width="10"
										height="6"
										viewbox="0 0 10 6"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0.294051 0.292198C0.685575 -0.0979418 1.31974 -0.0973192 1.71049 0.293589L5 3.58439L8.28951 0.293589C8.68027 -0.0973192 9.31443 -0.0979418 9.70595 0.292198C10.0975 0.682338 10.0981 1.3155 9.70734 1.70641L5.70892 5.70641C5.52103 5.89437 5.26598 6 5 6C4.73403 6 4.47897 5.89437 4.29108 5.70641L0.292658 1.70641C-0.098096 1.3155 -0.0974724 0.682338 0.294051 0.292198Z"
											fill="#2D2D2D"
										/>
									</svg>
								</a>
							</div>
						</div>
					</div>
				</div>
				<!-- ^^^^^^^^^^^^^^^^^^^^^^^^^^ -->
				<!-- RESULTS CONTAINER TEMPLATE -->
				<!-- ========================== -->
			</div>
		</div>
	</article>
</template>

<script>
import SvgCrossIcon from '~/assets/svgs/cross-icon.svg?inline';

export default {
	name: 'MainSearchPageCustom',

	components: {
		SvgCrossIcon,
	},

	inheritAttrs: false,

	props: {
		title: String,
	},

	data() {
		return {
			backlink: this.$store.state.site?.url || '/',
		};
	},

	beforeMount() {
		if (this.$routerHistory && this.$routerHistory.hasPrevious()) {
			const searchUrl =
				this.$store.state.site?.searchPage?.url || '/da/soegning/';
			const history = [
				this.backlink,
				...this.$routerHistory.getHistory(),
			];
			history.reverse();
			this.backlink = history.find((url) => url.indexOf(searchUrl) !== 0);
		}
	},
	mounted() {
		this.$refs.search.focus();
	},
};
</script>

<style lang="postcss">
@screen >=1440 {
	.d-search-page-custom__cludo-container {
		width: calc(
			100% + var(--theme-spacing-menu, var(--theme-spacing-menu--sm))
		) !important;
		margin-left: calc(
			var(--theme-spacing-menu, var(--theme-spacing-menu--sm)) / 2 * -1
		) !important;
	}
}
</style>
